module.exports = __webpack_public_path__ + "img/011曲明.500d2aa2.jpg";